import React, { DependencyList } from 'react';
import shallowEqual from 'shallowequal';

export function useShallowMemoize(value: any = {}) {
  const ref = React.useRef({});
  if (!shallowEqual(value, ref.current)) {
    ref.current = value;
  }
  return ref.current;
}
export default function useShallowMemo<T>(
  factory: () => T,
  dependencies: DependencyList,
) {
  return React.useMemo<T>(
    factory,
    dependencies.map((dependency) => {
      return useShallowMemoize(dependency);
    }),
  );
}
